import { useState, useEffect } from "react";
import { toast } from "sonner";
import { ChatCircleDots } from "@phosphor-icons/react";

/**
 * Admin control for KOSH's single approved pricing answer. KOSH replies with
 * exactly this text whenever a visitor asks about price/cost/budget, keeping
 * pricing consistent across every conversation. Leave blank to use the default.
 */
export default function KoshSettingsEditor({ settings, updateTheme, savingTheme }) {
  const [pricing, setPricing] = useState(settings?.kosh_pricing_statement || "");

  useEffect(() => { setPricing(settings?.kosh_pricing_statement || ""); }, [settings?.kosh_pricing_statement]);

  const save = (e) => {
    e?.preventDefault();
    updateTheme({ kosh_pricing_statement: pricing.trim() });
    toast.success(pricing.trim() ? "KOSH pricing answer saved." : "Cleared — KOSH will use the default pricing answer.");
  };

  const dirty = pricing.trim() !== (settings?.kosh_pricing_statement || "");

  return (
    <form onSubmit={save} className="flex items-start gap-4" data-testid="kosh-settings-editor">
      <ChatCircleDots size={22} color="#FF4500" weight="duotone" />
      <div className="flex-1">
        <h3 className="font-display text-xl">KOSH — approved pricing answer</h3>
        <p className="mt-1 text-[#8E8E93] text-sm">
          KOSH uses this exact wording every time a visitor asks about price, cost, or budget —
          so pricing stays consistent across conversations. It will translate it into the
          visitor&apos;s language but won&apos;t invent numbers. Leave blank to use the default.
        </p>
        <textarea
          value={pricing}
          onChange={(e) => setPricing(e.target.value)}
          data-testid="kosh-pricing-input"
          rows={4}
          className="ww-input mt-4 w-full"
          placeholder="e.g. Every Wisewit engagement is scoped to your problem. We start with a paid discovery, then propose a fixed scope and price…"
        />
        <div className="mt-3">
          <button type="submit" disabled={savingTheme || !dirty} className="btn-primary disabled:opacity-50" data-testid="kosh-pricing-save">
            {savingTheme ? "Saving…" : "Save pricing answer"}
          </button>
        </div>
      </div>
    </form>
  );
}
